import React from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import './narrow-form.scss';
import { LocaleString } from '@biw/intl';

class NarrowForm extends React.Component {

    static propTypes = {
        children: PropTypes.node,
        page: PropTypes.string.isRequired,
        clientLogo: PropTypes.string,
        headerTxt: PropTypes.string,
        errorsExist: PropTypes.bool
    }
    static defaultProps ={
        headerTxt: ''
    }
    render() {

        const {
            page,
            clientLogo,
            headerTxt,
            errorsExist
        } = this.props;

        const narrowPageClasses = classNames( {
            'narrow-form-page': true,
            [ page ]: true
        } );

        const formClasses = classNames( {
            'narrow-form': true,
            'error': errorsExist
        } );

        return (
            <div className={ narrowPageClasses }>
                {
                    clientLogo &&
                    <div className="client-logo">
                        <img src={ clientLogo } alt="client logo"/>
                    { headerTxt && <LocaleString TextComponent="h1" code={headerTxt} /> }
                    </div>

                }
                <div className={ formClasses }>
                    { this.props.children }
                </div>
            </div>
        );
    }
}

export default NarrowForm;
